const ORIGIN = 'https://api.hzqmtech.com' // 正式接口地址
// const ORIGIN = 'http://test-api.hzqmtech.com' // 测试接口地址

export default {
  // 处理url
  apiFilter(url) {
    const origin = location.origin

    if (origin === 'http://test-m.hzqmtech.com') {
      //测试
      return url.replace(
        // /http:\/\/47.99.172.20:4041/, //正式ip
        /https:\/\/api.hzqmtech.com/, //正式
        'http://test-api.hzqmtech.com' //测试接口地址
      )
    }
    return url
  },
  // 添加接口后记得在dev.env.js中的proxyTarget中也加入，不然会出现本地代理拦截的情况
  apis: {
    LOGIN: `${ORIGIN}/shop/auth/login`, // 登录
    captchaGet: `${ORIGIN}/shop/auth/captcha/get`, // 获取验证图片  以及token
    captchaCheck: `${ORIGIN}/shop/auth/captcha/verification/code`, // 滑动或者点选验证
    GET_CODE: `${ORIGIN}/shop/auth/getVerificationCode`, // 获取验证码
    LOG_OUT: `${ORIGIN}/shop/auth/logout`, // 退登
    PROVINCE: `${ORIGIN}/admin/common/areaTree`, // 获取省市区
    GET_BANK_LIST: `${ORIGIN}/admin/common/getOrganizationDetailListByType`, // 银行列表
    // GET_HOME_DATA: `${ORIGIN}/shop/merchant/merchantHomeInfo`, // 获取商户端首页信息
    WX_SILENT: `${ORIGIN}/shop/wechat/silentAuthorization`, // wx静默授权登陆 逻辑：前端请求接口 => 后端判断是否存此用户 => 有用户存token跳首页,无用户跳登陆页返回openId登陆时传给后端
    // GET_SHOP_ACCOUNTS: `${ORIGIN}/shop/user/select/`, // 查门店所有账号
    GET_SHOPLIST_BYID: `${ORIGIN}/shop/merchant/getShopListByTraderId`, // 获取商户绑定的门店列表
    // GET_ACCOUNT_PERMISSION: `${ORIGIN}/shop/user/selectAccountPermission`, // 查商户账号权限
    SWITCH_SHOP: `${ORIGIN}/shop/merchant/switchShop`, // 切换门店
    SWITCH_USER_COUNT: `${ORIGIN}/shop/user/switchUserShop`, // 切换账号
    GET_USERINFO: `${ORIGIN}/shop/user/selectUserInfo`, // 获取商户信息
    CHECK_CODE_COUPON: `${ORIGIN}/shop/merchant/merchantCheckCode`, // 校验核销券码
    GET_CODE_COUPON: `${ORIGIN}/shop/merchant/merchantWriteOffCode`, // 核销券码
    GET_VERIFICATION_CONFIG: `${ORIGIN}/shop/merchant/getVerificationConfig`, //获取核销配置信息

    GET_SAFE_MESSAGE: `${ORIGIN}/shop/merchant/getSafeCheckMessage`, // 获取安全检测信息
    UPDATE_SAFE_MESSAGE: `${ORIGIN}/shop/merchant/updateSafeCheckMessage`, //更新安全检测信息
    // 订单
    GET_TODAYORDER_LIST: `${ORIGIN}/shop/merchant/merchantTodayOrderList`, // 商户今日订单列表
    GET_ALLORDER_LIST: `${ORIGIN}/shop/merchant/merchantAllOrderList`, // 全部订单
    // UPDATAE_WRITEOFF_PIC: `${ORIGIN}/shopBillBackStage/updateShopWriteOffPic`, // 订单修改核销图片,不用了，在修改核销信息里边统一修改
    GET_ALLORDER_DETAILLIST: `${ORIGIN}/shop/merchant/merchantAllOrderDetailList`, // 全部订单详细列表
    GET_SECOND_CLASS: `${ORIGIN}/admin/common/getServiceClassList`, // 全部二级服务名
    // 门店信息
    SHOP_OPEN_INFO: `${ORIGIN}/shop/merchant/merchantShopBasicInfo`, // 商户门店营业信息
    SHOP_BASIC_INFO: `${ORIGIN}/shop/merchant/merchantShopDetailInfo`, // 商户端门店基本信息
    SHOP_MERCHANT_INFO: `${ORIGIN}/shop/merchant/merchantShopStoreInfo`, // 商户门店店铺信息
    SHOP_COMPANY_INFO: `${ORIGIN}/shop/merchant/merchantShopCompanyInfo`, // 商户门店企业信息
    SHOP_CERTIFICATE_PHOTO: `${ORIGIN}/shop/merchant/merchantUrlInfoList`, // 商户端证照店照
    // 修改门店信息页
    GET_DOOR_URL: `${ORIGIN}/shop/merchant/merchantChangeShopDoorUtl`, // 商户更换门头照
    GET_SHOP_STATUS: `${ORIGIN}/shop/merchant/merchantChangeShopStatus`, // 商户更改门店状态
    GET_BUSINESS_HOURS: `${ORIGIN}/shop/merchant/merchantChangeBusinessHours`, // 商户修改营业时间
    CHANGE_SHOP_DETAIL: `${ORIGIN}/shop/merchant/merchantChangeShopDetail`, // 商户端修改门店基本信息
    CHANGE_SHOP_STOREINFO: `${ORIGIN}/shop/merchant/merchantChangeShopStoreInfo`, // 商户端修改门店店铺信息
    CHANGE_SHOP_COMPANYINFO: `${ORIGIN}/shop/merchant/merchantChangeShopCompanyInfo`, // 商户端修改门店企业信息
    CHANGE_SHOP_URLINFO: `${ORIGIN}/shop/merchant/merchantChangeUrlInfo`, // 商户端修改证照店照
    // 门店服务
    SERVICE_LIST: `${ORIGIN}/shop/merchant/merchantServiceList`, // 商户获取门店服务列表
    // 关闭服务页
    CLOSE_SERVICE: `${ORIGIN}/shop/merchant/merchantCloseServiceSign`, // 商户端关闭服务

    // 员工管理
    SELECT_USER_INFO: `${ORIGIN}/shop/user/select`, // 查询当前商户信息
    // 添加账号页
    ADD_USER_ACCOUNT: `${ORIGIN}/shop/user/addUserAccount`, // 新增账号
    SHOP_USER_UPDATE: `${ORIGIN}/shop/user/update`, // 商户员工编辑和删除

    // 结款管理
    SETTLEMENT_LIST: `${ORIGIN}/shop/merchant/merchantSettlementList`, // 商户结款记录
    // SETTLEMENT_ORDER_LIST: `${ORIGIN}/shop/merchant/matchMerchantSettlement`, // 商户出账订单
    SETTLEMENT_ORDER_INFO: `${ORIGIN}/shop/merchant/applyMerchantSettlementDetail`, // 商户出账详情
    SETTLEMENT_ORDER_SUBMIT: `${ORIGIN}/shop/merchant/applyMerchantSettlement`, // 申请出账

    // 收款账户
    PROCEEDS_BANKCAR_INFO: `${ORIGIN}/shop/merchant/merchantBankCarInfo`, // 商户端银行卡信息
    PROCEEDS_CHANGE_BANKCAR_INFO: `${ORIGIN}/shop/merchant/merchantChangeBankCardInfo`, // 商户端修改银行卡信息
    // 公共
    RENDER_MAP: `https://www.xiaokunkeji.cn/user/vue/locateline.html?isLocate=1`, // 渲染地图 不要调User的了，重新画地图吧
    XK_MAP: `https://www.xiaokunkeji.cn/user/vue/locateline.html`, // 地图地址 不要调User的了，重新画地图吧
    // 加盟
    SHOP_VERIFY_LOGIN: `${ORIGIN}/admin/shop-check/checkShopUser`, // 登陆校验-查看门店详情
    SHOP_ADDSHOP: `${ORIGIN}/admin/shop-check/add`, // 新增门店签约
    SHOP_EDITSHOP: `${ORIGIN}/shop/merchant/editShopSignStatus`, // 查看已有门店签约
    ADD_SHOP_DETAIL: `${ORIGIN}/shop/merchant/getShopDetail`, // 门店详情
    PAY_UNIFIED: `${ORIGIN}/pay/unified`, // 扫码支付
    PAY_QUERY: `${ORIGIN}/pay/query`, // 支付结果查询
    INDEX_CONFIG: `${ORIGIN}/distribution`, // 渠道下单首页配置接口
    GOOD_LISTS: `${ORIGIN}/goods/distribution`, // 商品列表
    GOOD_SUBMIT: `${ORIGIN}/goods/order/submit`, // 商品下单
    SHOP_DISTR: `${ORIGIN}/shopdistr/order/submit`, // 创建服务单
    GOODS_DETAIL: `${ORIGIN}/goods/order/detail`, // 购买商品详情查询
    PAY_CLOSE: `${ORIGIN}/pay/close`, // 关闭支付定单接口
    // GET_SHOP_URL_PROVIDE: `${ORIGIN}/distribution/whether/access`,
    GET_QUERY_TP: `${ORIGIN}/shop/wax/waxShop`, // 太平财险
    GET_VERUFUCATION_CODE: `${ORIGIN}/shop/wax/getVerification`, // 太平券码验证
    TO_VALIDATE: `${ORIGIN}/shop/wax/waxOrder`, // 太平核销
    GET_MERCHANT_YEAR: `${ORIGIN}/shop/merchant/listYearMonth`, //商户查询x年的月订单统计
    GET_MERCHANT_MONTH: `${ORIGIN}/shop/merchant/month`, //商户查询x年x月的订单统计
    GET_MERCHANT_NUM: `${ORIGIN}/shop/merchant/chargeCount`, //商户查询本月出账次数
    TO_SHOP_ACCOUNT: `${ORIGIN}/shop/merchant/beforehandSettlement`, //商户出账
    GET_AGREEMERT_INFO: `${ORIGIN}/shop/merchant/agreement`, //小鲲协议
    // 抖音
    GET_TIKTOY_MERCHANT_PREPARE: `${ORIGIN}/tiktok/merchant/prepare`, //抖音核销确认
    GET_TIKTOK_VERIFY: `${ORIGIN}/tiktok/merchant/verify`, //抖音核销
    GET_TIKTOK_ORDER_YEAR_RECORD: `${ORIGIN}/tiktok/merchant/order/year`, //抖音核销年记录
    GET_TIKTOK_ORDER_DAY_RECORD: `${ORIGIN}/tiktok/merchant/order/day`, //抖音核销日记录
    QUERY_TIKTOK_CANCEL: `${ORIGIN}/tiktok/merchant/cancel`, //抖音撤销核销
    GET_TIKTOK_MERCHANT_LIST: `${ORIGIN}/tiktok/merchant/list`, //核销列表
    GET_TIKTOK_MAINTAIM_MERCHANT_PERPARE: `${ORIGIN}/tiktok/merchant/maintain/verify`, // 抖音保养核销
    //
    GET_MERCHANT_VERIFY_FIRST_TIME: `${ORIGIN}/shop/merchant/verifyFirstTime`, // 验证用户是否第一次登录
    UploadBase64File: `${ORIGIN}/admin/common/uploadBaseFile`, //base64流上传
    GetSignature: `${ORIGIN}/shop/merchant/getSignature`, //生成电子签名
    UPLOAD_INVOICE: `${ORIGIN}/admin/shopInvoiceBill/upload`, //用户上传发票
    UPLOAD_URL: `${ORIGIN}/admin/common/upload`, //上传
    INVOICE_INFO: `${ORIGIN}/admin/shopInvoiceBill/getInvoiceInfo`, //查看发票信息
    //
    ADD_USER_NOTICE: `${ORIGIN}/shop/user/addUserNotice`, //用户看过某个公告
    ADD_AGREEMENT: `${ORIGIN}/shop/merchant/addAgreement`, //商户签订协议

    UPLOAD_URL_TO_PDF: `${ORIGIN}/admin/common/imageListToPdf`, //图片列表转pdf

    SAVE_REST_TIME: `${ORIGIN}/shop/restTime/save` //保存节假日休息时间
  },
  pages: {
    // home
    '/pages/home/index': {
      title: '商户管理首页',
      vue: require('@/pages/home/index.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    '/pages/orderAll/index': {
      title: '全部订单',
      vue: require('@/pages/orderAll/index.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    '/pages/orderToday/index': {
      title: '今日订单',
      vue: require('@/pages/orderToday/index.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    '/pages/orderDetail/index': {
      title: '订单详情',
      vue: require('@/pages/orderDetail/index.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 门店信息
    '/pages/shopInfo/index': {
      title: '门店信息',
      vue: require('@/pages/shopInfo/index.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    '/pages/changeShopInfo/index': {
      title: '修改门店信息',
      vue: require('@/pages/changeShopInfo/index.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 门店服务
    '/pages/shopService/index': {
      title: '门店服务',
      vue: require('@/pages/shopService/index.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 关闭门店服务
    '/pages/shopServeClose/index': {
      title: '门店服务',
      vue: require('@/pages/shopServeClose/index.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 员工管理
    '/pages/userManagement/index': {
      title: '员工管理',
      vue: require('@/pages/userManagement/index.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    '/pages/accountAccessPic/index': {
      title: '权限管理',
      vue: require('@/pages/accountAccessPic/index.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    '/pages/addAccessUser/index': {
      title: '增加账号',
      vue: require('@/pages/addAccessUser/index'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },

    // 结款管理
    '/pages/settlementRecords/index': {
      title: '结算管理',
      vue: require('@/pages/settlementRecords/index.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 确认信息
    '/pages/confirmInfo/index': {
      title: '确认信息',
      vue: require('@/pages/settlementRecords/confirmInfo.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },

    // 收款账户
    '/pages/accounts/index': {
      title: '添加收款账户',
      vue: require('@/pages/accounts/index.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 核销券页面
    '/pages/verifyCode/index': {
      title: '券码核销',
      vue: require('@/pages/verifyCode/index.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 核销信息 上传图片
    '/pages/verifyUploadImg/index': {
      title: '核销信息',
      vue: require('@/pages/verifyCode/verifyUploadImg.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 修改核销信息
    '/pages/editVerifyImg/index': {
      title: '修改核销信息',
      vue: require('@/pages/verifyCode/editVerifyImg.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 核销信息 上传图片
    '/pages/orderDetail/onlineSign': {
      title: '在线签名',
      vue: require('@/pages/verifyCode/onlineSign.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 商户加盟页
    '/pages/cooperation/index': {
      title: '小鲲车服',
      vue: require('@/pages/cooperation/index.vue'),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    // 填写加盟信息
    '/pages/cooperationShopInfo/index': {
      title: '填写信息',
      vue: require('@/pages/cooperation/shopInfo.vue'),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    // 通用页面bankList
    '/pages/bankList/index': {
      title: '填写信息',
      vue: require('@/pages/common/bankList.vue'),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    '/pages/agreement/index': {
      title: '小鲲车服入驻协议',
      vue: require('@/pages/common/agreement.vue'),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    '/pages/cashiers/index': {
      title: '小鲲收银台',
      vue: require('@/pages/cashiers/index.vue'),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    '/pages/shopBill/index': {
      title: '',
      vue: require('@/pages/shopBill/index.vue'),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    '/pages/cashiers/billDetail': {
      title: '订单详情',
      vue: require('@/pages/cashiers/billDetail.vue'),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    // 太平核销信息
    '/pages/verify/code': {
      title: '核销信息',
      vue: require('@/pages/verifyCode/tpCode.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    '/pages/home/text': {
      title: '结算流程通知',
      vue: require('@/pages/home/text.vue'),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    '/pages/home/textInvoice': {
      //有发票的
      title: '结算流程通知',
      vue: require('@/pages/home/textInvoice.vue'),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    // 核销记录（年）
    '/pages/yearRecord/index': {
      title: '',
      vue: require('@/pages/record/year.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 核销记录（月）
    '/pages/monthRecord/index': {
      title: '',
      vue: require('@/pages/record/month.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 核销记录（日）
    '/pages/dayRecord/index': {
      title: '',
      vue: require('@/pages/record/day.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 抖音验券核销
    '/pages/tiktok/verify': {
      title: '验券核销',
      vue: require('@/pages/record/verify.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 抖音验券核销结果
    '/pages/tiktok/result': {
      title: '核销结果',
      vue: require('@/pages/record/writeResult.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 发票管理
    '/pages/invoice/index': {
      title: '发票管理',
      vue: require('@/pages/invoice/index.vue'),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 服务协议
    '/pages/assignMent/index': {
      title: '服务协议',
      vue: require('@/pages/assignMent/index.vue'),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    // 服务协议
    '/pages/common/review': {
      title: 'PDF预览',
      vue: require('@/pages/common/review.vue'),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/configs/config.js